var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      regex: /^[a-zA-Z0-9\-\_\.]*$/
                    },
                    expression:
                      "{ required: true, regex: /^[a-zA-Z0-9\\-\\_\\.]*$/ }"
                  }
                ],
                attrs: {
                  outlined: "",
                  autocomplete: "nope",
                  label: "Account Name",
                  name: "Account Name",
                  "error-messages": _vm.errors.collect("Log In")
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function fn() {
                      return [
                        !_vm.isMobileDevice
                          ? _c(
                              "div",
                              {
                                staticClass: "append-bg"
                              },
                              [
                                _c("domain-select", {
                                  staticStyle: {
                                    "margin-top": "10px"
                                  },
                                  attrs: {
                                    "no-label": "",
                                    "hide-details": "",
                                    flat: "",
                                    solo: "",
                                    "prepend-inner-icon": "mdi-at"
                                  },
                                  model: {
                                    value: _vm.domain,
                                    callback: function callback($$v) {
                                      _vm.domain = $$v
                                    },
                                    expression: "domain"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.username,
                  callback: function callback($$v) {
                    _vm.username = $$v
                  },
                  expression: "username"
                }
              })
            ],
            1
          ),
          _vm.isMobileDevice
            ? _c(
                "v-col",
                {
                  staticClass: "py-0",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("domain-select", {
                    attrs: {
                      outlined: "",
                      label: "Select a Domain",
                      "prepend-inner": false
                    },
                    model: {
                      value: _vm.domain,
                      callback: function callback($$v) {
                        _vm.domain = $$v
                      },
                      expression: "domain"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-input-label", [_vm._v("Password")]),
              _c("compact-password", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:8",
                    expression: "'required|min:8'"
                  }
                ],
                attrs: {
                  outlined: "",
                  autocomplete: "new-password",
                  "data-vv-name": "password",
                  "data-vv-as": "Password",
                  "error-messages": _vm.errors.collect("password"),
                  "with-generator": ""
                },
                model: {
                  value: _vm.password,
                  callback: function callback($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pt-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.submit
                  }
                },
                [_vm._v("Create Account")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }